import { useState } from 'react';
import { Image, Pressable, ScrollView, StyleSheet, Text, View } from 'react-native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import colors from '../theme';
import { RootStackParamList } from '../navigation/RootNavigator';

const slides = [
  {
    title: 'Chào mừng đến với Aural',
    description: 'Nghe những câu chuyện hay và khám phá cuốn sách nói tiếp theo cho bạn.',
    accent: '#BDEBFF',
    image: require('../../assets/aural-onboard-1.png'),
  },
  {
    title: 'Trải nghiệm liền mạch',
    description: 'Theo dõi danh sách nghe, lựa chọn nổi bật và gợi ý phù hợp với bạn.',
    accent: '#D9F4EC',
    image: require('../../assets/aural-onboard-2.png'),
  },
  {
    title: 'Nghe và đọc mọi lúc',
    description: 'Lưu truyện yêu thích và tiếp tục hành trình nghe sách ở bất cứ đâu.',
    accent: '#E7E8FF',
    image: require('../../assets/aural-onboard-3.png'),
  },
];

type Props = NativeStackScreenProps<RootStackParamList, 'Onboarding'>;

export default function OnboardingScreen({ navigation }: Props) {
  const [index, setIndex] = useState(0);
  const slide = slides[index];

  return (
    <ScrollView contentContainerStyle={styles.container} showsVerticalScrollIndicator={false}>
      <View style={[styles.hero, { backgroundColor: slide.accent }]}>
        <Image source={slide.image} style={styles.heroImage} resizeMode="cover" />
      </View>
      <Text style={styles.title}>{slide.title}</Text>
      <Text style={styles.description}>{slide.description}</Text>
      <View style={styles.pagination}>
        {slides.map((_, dotIndex) => (
          <View key={dotIndex} style={[styles.dot, dotIndex === index && styles.dotActive]} />
        ))}
      </View>
      <View style={styles.actions}>
        <Pressable style={[styles.button, styles.primaryButton]} onPress={() => navigation.navigate('Signup')}>
          <Text style={styles.primaryButtonText}>Đăng ký</Text>
        </Pressable>
        <Pressable style={[styles.button, styles.secondaryButton]} onPress={() => navigation.navigate('Login')}>
          <Text style={styles.secondaryButtonText}>Đăng nhập</Text>
        </Pressable>
      </View>
      <Pressable style={styles.guestButton} onPress={() => navigation.navigate('PreferencesGenre')}>
        <Text style={styles.guestText}>Tiếp tục không đăng nhập</Text>
      </Pressable>
      <Pressable style={styles.footer} onPress={() => setIndex((prev) => (prev + 1) % slides.length)}>
        <Text style={styles.footerText}>Trang tiếp</Text>
      </Pressable>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    backgroundColor: colors.background,
    paddingHorizontal: 24,
    paddingTop: 44,
    paddingBottom: 24,
  },
  hero: {
    height: 268,
    borderRadius: 8,
    marginBottom: 26,
    overflow: 'hidden',
  },
  heroImage: {
    width: '100%',
    height: '100%',
  },
  title: {
    color: colors.textPrimary,
    fontSize: 20,
    fontWeight: '700',
    marginBottom: 9,
    textAlign: 'center',
  },
  description: {
    color: colors.textSecondary,
    fontSize: 14,
    lineHeight: 16,
    marginBottom: 22,
    textAlign: 'center',
  },
  pagination: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 5,
    marginBottom: 22,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: colors.muted,
  },
  dotActive: {
    width: 18,
    backgroundColor: colors.button,
  },
  actions: {
    flexDirection: 'row',
    gap: 12,
    marginBottom: 13,
  },
  button: {
    flex: 1,
    borderRadius: 5,
    paddingVertical: 11,
    alignItems: 'center',
  },
  primaryButton: {
    backgroundColor: colors.button,
  },
  primaryButtonText: {
    color: colors.buttonText,
    fontWeight: '700',
    fontSize: 14,
  },
  secondaryButton: {
    backgroundColor: colors.background,
    borderWidth: 1,
    borderColor: colors.border,
  },
  secondaryButtonText: {
    color: colors.textPrimary,
    fontWeight: '700',
    fontSize: 14,
  },
  guestButton: {
    alignItems: 'center',
    paddingVertical: 10,
  },
  guestText: {
    color: colors.button,
    fontSize: 14,
    fontWeight: '700',
  },
  footer: {
    alignItems: 'center',
    marginTop: 4,
  },
  footerText: {
    color: colors.textSecondary,
    fontSize: 12,
  },
});
